import moment from "moment";
import React, { useState, useMemo, useEffect } from "react";
import Modal from 'react-bootstrap/Modal';
import ModalHeader from 'react-bootstrap/ModalHeader';
import ModalTitle from 'react-bootstrap/ModalTitle';
import Collapse from 'react-bootstrap/Collapse';
import { FaArrowRight } from "react-icons/fa";
import { FiUpload } from "react-icons/fi";
import { NumericFormat } from "react-number-format";
import Api, { exceptionNotificationAPI } from "../../services/api";
import Button from "../Button";
import GetTypeInput from "../FormInput/set";
import { success_message } from "../Toast";
// import ModalBody from 'react-bootstrap/ModalBody';
import { Header, ModalBody } from './styles';
import CheckboxTree from 'react-checkbox-tree';
import Swal from 'sweetalert2';
import {
    MdCheckBox,
    MdCheckBoxOutlineBlank,
    MdChevronRight,
    MdKeyboardArrowDown,
    MdAddBox,
    MdIndeterminateCheckBox,
    MdFolder,
    MdFolderOpen,
    MdInsertDriveFile
} from "react-icons/md";
import 'react-checkbox-tree/lib/react-checkbox-tree.css';


export default function ModalRejectPartial({ showModalRejectPartial, setShowModalRejectPartial, ssksToReject, moduleID, selectedCompanyID, selectedReportYearID, cultureTypeID, loadData, setLoading, userRoles, rejectedThriveValuesList }) {

    const [selectedSskpis, setSelectedSskpis] = useState([]);
    const [groupByColumn, setGroupByColumn] = useState(false);
    const [groupedSSKpis, setGroupedSSKpis] = useState();
    const [checked, setChecked] = useState([]);
    const [expanded, setExpanded] = useState([]);
    const [expandedGroups, setExpandedGroups] = useState(new Set());

    // Inicializar checkboxes selecionados baseado em rejectedThriveValuesList
    useEffect(() => {
        if (rejectedThriveValuesList && rejectedThriveValuesList.length > 0 && ssksToReject && ssksToReject.length > 0) {
            const preSelectedSskpis = ssksToReject.filter(ssk => {
                return rejectedThriveValuesList.some(rejected => {
                    const sskSubSectionKPIID = ssk.subSectionKpiID || ssk.subSectionKPIID;
                    const rejectedSubSectionKPIID = rejected.subSectionKpiID || rejected.subSectionKPIID;

                    return sskSubSectionKPIID === rejectedSubSectionKPIID &&
                        ssk.rowIndex === rejected.rowIndex &&
                        ssk.columnIndex === rejected.columnIndex;
                });
            });
            setSelectedSskpis(preSelectedSskpis);
        } else {
            setSelectedSskpis([]);
        }
    }, [rejectedThriveValuesList, ssksToReject]);

    async function UnselectAll() {
        setSelectedSskpis([]);
        if (groupByColumn && groupedSSKpis) {
            setChecked([]);
        }
    }

    async function SelectAll() {
        var AllSsks = [];
        setSelectedSskpis([]);

        AllSsks = ssksToReject;
        setSelectedSskpis(AllSsks);

        // Se estiver usando CheckboxTree, também atualizar o estado checked
        if (groupByColumn && groupedSSKpis) {
            const allCheckedValues = [];
            groupedSSKpis.forEach((subSection) => {
                subSection.children.forEach((column) => {
                    column.children.forEach((item) => {
                        allCheckedValues.push(item.value);
                    });
                });
            });
            setChecked(allCheckedValues);
        }
    }

    /** Valores do CheckboxTree (folhas) a partir da seleção da lista */
    const checkedValuesFromSelected = (formatedList, selected) => {
        if (!formatedList?.length || !selected?.length) return [];
        const checkedValues = [];
        formatedList.forEach((subSection) => {
            subSection.children.forEach((column) => {
                column.children.forEach((item) => {
                    const sskpiID = item.value.split("-")[0];
                    const row = item.value.split("-")[3];
                    const matchingSsk = selected.find(ssk =>
                        String(ssk.subSectionKpiID) === String(sskpiID) &&
                        (row === undefined ? true : String(ssk.rowIndex) === String(row))
                    );
                    if (matchingSsk) {
                        checkedValues.push(item.value);
                    }
                });
            });
        });
        return checkedValues;
    };

    /** Objetos ssk a partir dos valores checados na árvore (mesma regra de RejectSelectedSskpis) */
    const selectedFromCheckedValues = (checkedValues, ssks) => {
        if (!checkedValues?.length || !ssks?.length) return [];
        const picked = [];
        checkedValues.forEach((e) => {
            const sskpiID = e.split("-")[0];
            const row = e.split("-")[3];
            const toAdd = ssks.find(x =>
                String(x.subSectionKpiID) === String(sskpiID) &&
                (row === undefined ? true : String(x.rowIndex) === String(row))
            );
            if (toAdd && !picked.some(p =>
                p.subSectionKpiID === toAdd.subSectionKpiID &&
                p.rowIndex === toAdd.rowIndex &&
                p.columnIndex === toAdd.columnIndex
            )) {
                picked.push(toAdd);
            }
        });
        return picked;
    };

    async function handleGroupByColumn(isGroup) {
        let formatedList = []
        if (isGroup && !groupedSSKpis) {
            let newList = Object.groupBy(ssksToReject, ({ subSectionDescription }) => subSectionDescription)
            Object.keys(newList).forEach(key => {
                newList[key] = Object.groupBy(newList[key], ({ columnDesc }) => columnDesc)
            })

            Object.keys(newList).map((key, iss) => {
                let subSection = {
                    value: key,
                    label: key,
                    children: []
                }

                Object.keys(newList[key]).map((key2, i) => {
                    let column = {
                        value: key2 + "-" + iss + "-" + i,
                        label: key2,
                        children: newList[key][key2].map((e, i2) => {
                            return { value: e.subSectionKpiID + "-" + i + "-" + i2 + (e.rowIndex != null ? "-" + e.rowIndex : ""), label: (e.rowIndex != null ? (e.rowIndex + 1) + " - " : "") + e.refNumber + " - " + e.kpiDescription }
                        })
                    }
                    subSection.children.push(column)
                })
                formatedList.push(subSection)
            })
            setGroupedSSKpis(formatedList)

            // Inicializar checked baseado em selectedSskpis
            setChecked(checkedValuesFromSelected(formatedList, selectedSskpis));
        } else if (isGroup && groupedSSKpis) {
            // Voltando da lista para agrupado: manter árvore e alinhar checked + seleção
            setChecked(checkedValuesFromSelected(groupedSSKpis, selectedSskpis));
        }

        setGroupByColumn(isGroup)
    }

    async function SelectToReject(ssk, id) {

        var SskpiItem = selectedSskpis.find(x => x.subSectionKpiID == ssk.subSectionKpiID && x.rowIndex == ssk.rowIndex && x.columnIndex == ssk.columnIndex);

        if (SskpiItem != null) {
            var selectedSSksFiltered = selectedSskpis.filter(x => x.subSectionKpiID != ssk.subSectionKpiID || x.rowIndex != ssk.rowIndex || x.columnIndex != ssk.columnIndex);;
            setSelectedSskpis(selectedSSksFiltered);
        }
        else {
            var newArray = [];
            newArray = selectedSskpis;
            newArray = [...newArray, ssk];
            setSelectedSskpis(newArray);
        }
    }

    const orderedItems = useMemo(() => {
        if (!ssksToReject || ssksToReject.length === 0) return [];

        const grouped = {};
        const result = [];
        const processedGroups = new Set();

        ssksToReject.forEach((ssk, index) => {
            if (ssk.rowIndex != null) {
                // Agrupar apenas itens com row
                const subSection = ssk.subSectionDescription || 'No SubSection';
                const row = ssk.rowIndex;
                const key = `${subSection}-${row}`;

                if (!grouped[key]) {
                    grouped[key] = {
                        subSection: subSection,
                        row: row,
                        items: [],
                        originalIndex: index
                    };
                }
                grouped[key].items.push(ssk);

                // Adicionar o grupo na ordem quando encontrar o primeiro item
                if (!processedGroups.has(key)) {
                    processedGroups.add(key);
                    result.push({
                        type: 'group',
                        key: key,
                        group: grouped[key]
                    });
                }
            } else {
                // Itens sem row mantêm como estavam
                result.push({
                    type: 'item',
                    item: ssk,
                    originalIndex: index
                });
            }
        });

        return result;
    }, [ssksToReject]);

    const toggleGroup = (key) => {
        setExpandedGroups(prev => {
            const newSet = new Set(prev);
            if (newSet.has(key)) {
                newSet.delete(key);
            } else {
                newSet.add(key);
            }
            return newSet;
        });
    };

    const handleGroupCheckbox = (groupItems, isChecked) => {
        if (isChecked) {
            // Selecionar todos os itens do grupo
            const newSelected = [...selectedSskpis];
            groupItems.forEach(ssk => {
                const exists = newSelected.find(x =>
                    x.subSectionKpiID == ssk.subSectionKpiID &&
                    x.rowIndex == ssk.rowIndex &&
                    x.columnIndex == ssk.columnIndex
                );
                if (!exists) {
                    newSelected.push(ssk);
                }
            });
            setSelectedSskpis(newSelected);
        } else {
            // Deselecionar todos os itens do grupo
            const newSelected = selectedSskpis.filter(ssk => {
                return !groupItems.find(groupItem =>
                    groupItem.subSectionKpiID == ssk.subSectionKpiID &&
                    groupItem.rowIndex == ssk.rowIndex &&
                    groupItem.columnIndex == ssk.columnIndex
                );
            });
            setSelectedSskpis(newSelected);
        }
    };

    const isGroupAllSelected = (groupItems) => {
        return groupItems.every(ssk =>
            selectedSskpis.find(x =>
                x.subSectionKpiID == ssk.subSectionKpiID &&
                x.rowIndex == ssk.rowIndex &&
                x.columnIndex == ssk.columnIndex
            ) != null
        );
    };
    async function save(objToRequest) {
        await Api.post(`ThriveValue/reject`, objToRequest).then((result) => {
            success_message("The data was rejected successfully!");
            setLoading(false);
            loadData();
            setShowModalRejectPartial(false);
        }).catch((error) => {
            exceptionNotificationAPI(error);
            setLoading(false);
        });
    }

    async function RejectSelectedSskpis() {
        setLoading(true);

        let rejectedSskList = []

        if (!groupByColumn) {
            selectedSskpis.forEach((ssk) => {
                rejectedSskList.push(
                    {
                        "subSectionKPIID": ssk.subSectionKpiID,
                        "columnIndex": ssk.columnIndex,
                        "rowIndex": ssk.rowIndex,
                        "rejectedInThriveValueVersionID": ssk.rejectedInVersion
                    }
                );
            });
        } else {
            checked.forEach(e => {
                let sskpiID = e.split("-")[0]
                let row = e.split("-")[3]
                let toAdd = ssksToReject.find(x => x.subSectionKpiID == sskpiID && (row === undefined ? true : x.rowIndex == row))

                rejectedSskList.push(
                    {
                        "subSectionKPIID": toAdd.subSectionKpiID,
                        "columnIndex": toAdd.columnIndex,
                        "rowIndex": toAdd.rowIndex,
                        "rejectedInThriveValueVersionID": toAdd.rejectedInVersion
                    }
                );
            })
        }

        const objToRequest = {
            moduleID: moduleID,
            selectedCompanyID: selectedCompanyID,
            commentApprover: "Partial Reject",
            reportYearID: selectedReportYearID,
            cultureTypeID: cultureTypeID != null ? cultureTypeID : null,
            rejectedSskList: rejectedSskList
        }

        // Buscar subSectionKPIs correlacionadas
        await Api.post(`ThriveValue/GetCorrelatedSSkpis`, objToRequest).then(async (result) => {
            const correlatedSSkpis = result?.data?.response;

            // Verificar se retornou subSectionKPIs relacionadas
            if (correlatedSSkpis && correlatedSSkpis.length > 0) {
                // Extrair refNumbers únicos das subSectionKPIs correlacionadas
                const refNumbers = correlatedSSkpis
                    .map(ssk => ssk.refNumber)
                    .filter((ref, index, self) => ref && self.indexOf(ref) === index)
                    .sort((a, b) => {
                        // Ordenar numericamente se possível, caso contrário alfabeticamente
                        const numA = parseInt(a);
                        const numB = parseInt(b);
                        if (!isNaN(numA) && !isNaN(numB)) {
                            return numA - numB;
                        }
                        return a.localeCompare(b);
                    });

                // Construir mensagem com os refNumbers
                const refNumbersText = refNumbers.length > 0
                    ? `<strong>${refNumbers.join(', ')}</strong>`
                    : `${correlatedSSkpis.length} SubSectionKPIs`;

                // Mostrar alerta de confirmação
                const confirmResult = await Swal.fire({
                    title: 'Correlated SubSectionKPIs Found',
                    html: `Found correlated SubSectionKPIs with refNumbers: ${refNumbersText}<br/><br/>Do you want to reject these correlated SubSectionKPIs?`,
                    icon: 'warning',
                    showDenyButton: true,
                    confirmButtonColor: '#112A61',
                    denyButtonColor: '#B0B0BB',
                    denyButtonText: 'No',
                    confirmButtonText: 'Yes',
                    showCloseButton: false,
                    allowOutsideClick: false
                });

                if (confirmResult.isConfirmed) {
                    // Adicionar as relacionadas ao rejectedSskList
                    correlatedSSkpis.forEach((correlatedSSk) => {
                        // Verificar se já não está na lista para evitar duplicatas
                        // Usar == para comparar null/undefined corretamente
                        const alreadyExists = rejectedSskList.some(
                            existing => existing.subSectionKPIID === correlatedSSk.subSectionKPIID
                                && existing.columnIndex == correlatedSSk.columnIndex
                                && existing.rowIndex == correlatedSSk.rowIndex
                        );

                        if (!alreadyExists) {
                            rejectedSskList.push({
                                "subSectionKPIID": correlatedSSk.subSectionKPIID,
                                "columnIndex": correlatedSSk.columnIndex ?? null,
                                "rowIndex": correlatedSSk.rowIndex ?? null,
                                "rejectedInThriveValueVersionID": correlatedSSk.rejectedInThriveValueVersionID
                            });
                        }
                    });

                    // Atualizar objToRequest com a lista completa
                    objToRequest.rejectedSskList = rejectedSskList;

                    // Chamar save com as correlacionadas incluídas
                    await save(objToRequest);
                } else {
                    // Usuário não confirmou, não chamar save
                    await save(objToRequest);
                }
            } else {
                // Não há correlacionadas, chamar save normalmente
                await save(objToRequest);
            }
        }).catch((error) => {
            exceptionNotificationAPI(error);
            setLoading(false);
        });
    }

    const formatValuesInTooltipNumber = (
        value,
        decimalSeparator,
        decimalScale,
        suffix,
      ) => {
        return (typeof value == 'number') ? (
            <NumericFormat
              value={value}
              thousandsGroupStyle="thousand"
              decimalSeparator={
                decimalSeparator != ''
                  ? decimalSeparator
                  : '.'
              }
              decimalScale={
                decimalScale
              }
              suffix={suffix}
              displayType="text"
              type="text"
              valueIsNumericString={true}
              thousandSeparator={true}
              allowNegative={true}
              allowLeadingZeros={false}
              allowEmptyFormatting={true}
            />
          ) : (
            <>
              <span>
                {value}
              </span>
            </>
          );
      };

    return (

        <Modal
            show={showModalRejectPartial}
            onHide={() => {
                setShowModalRejectPartial(false);
            }}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <ModalHeader closeButton>
                <ModalTitle id="contained-modal-title-vcenter">
                    <Header>{userRoles.includes("RoleAdmin") ? 'Partial reactivation' : 'Partial approval / rejection'}</Header>
                </ModalTitle>
            </ModalHeader>
            <ModalBody>

                <div style={{ margin: "0.5rem 0" }}>{userRoles.includes("RoleAdmin") ? 'Please, select below all the KPIs to reactivate. Reactivated KPIs will be reopened for edition and need to go through the approval process again.' : 'Please, select below all the KPIs to reject. Rejected KPIs will be reopened for edition and need to go through the approval process again. Note that all the others that are not selected will be automatically closed for edition.'}</div>
                <div style={{ borderBottom: "var(--bs-modal-header-border-width) solid", marginTop: "1rem", marginBottom: "1rem", borderColor: "#d2d2d2" }}></div>

                <div style={{ marginTop: "1rem", marginBottom: "1rem" }} >
                    <Button style={{ marginRight: "1rem" }} onClick={() => SelectAll()}>Select all</Button>
                    <Button onClick={() => UnselectAll()}>Unselect all</Button>
                    {
                        groupByColumn ?
                            <Button style={{ float: "right" }} onClick={() => handleGroupByColumn(false)}>Show list</Button>
                            :

                            <Button style={{ float: "right" }} onClick={() => handleGroupByColumn(true)}>Show grouped by columns</Button>
                    }
                </div>
                <>
                    {
                        !groupByColumn ?
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th scope="col" className="col-sm-1">Select KPIs to reject</th>
                                        <th scope="col" className="col-sm-1">KPI Number</th>
                                        <th scope="col" className="col-sm-5">KPI Description</th>
                                        <th scope="col" className="col-sm-3">Column</th>
                                        <th scope="col" className="col-sm-2">Value</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {orderedItems?.length > 0 ? orderedItems.map((item, index) => {
                                        if (item.type === 'group') {
                                            const group = item.group;
                                            const groupKey = item.key;
                                            const isExpanded = expandedGroups.has(groupKey);
                                            const groupLabel = `${group.subSection} - Row ${group.row + 1}`;
                                            const isAllSelected = isGroupAllSelected(group.items);

                                            return (
                                                <React.Fragment key={groupKey}>
                                                    <tr style={{ backgroundColor: '#f5f5f5' }}>
                                                        <td style={{ padding: '0.75rem', verticalAlign: "middle" }}>
                                                            <div className="custom-control custom-checkbox">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={isAllSelected}
                                                                    className="custom-control-input"
                                                                    onChange={(e) => handleGroupCheckbox(group.items, e.target.checked)}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                />
                                                            </div>
                                                        </td>
                                                        <td colSpan={4} style={{ padding: '0.75rem', cursor: 'pointer' }} onClick={() => toggleGroup(groupKey)}>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                                                {isExpanded ?
                                                                    <MdKeyboardArrowDown size={20} /> :
                                                                    <MdChevronRight size={20} />
                                                                }
                                                                <b>{groupLabel}</b>
                                                                <span style={{ color: '#666', fontSize: '0.9em' }}>({group.items.length} item{group.items.length !== 1 ? 's' : ''})</span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan={5} style={{ padding: 0 }}>
                                                            <Collapse in={isExpanded}>
                                                                <div>
                                                                    <table className="table" style={{ margin: 0 }}>
                                                                        <tbody>
                                                                            {group.items.map((ssk, itemIndex) => {
                                                                                var unitMeasure = GetTypeInput(ssk.unitMeasure.unitMeasureID, ssk.unitMeasure.type);
                                                                                return (
                                                                                    <tr key={`${ssk.subSectionKpiID}-${ssk.rowIndex}-${ssk.columnIndex}-${itemIndex}`}>
                                                                                        <td style={{ verticalAlign: "middle", width: "10%" }}>
                                                                                            <div className="custom-control custom-checkbox">
                                                                                                <input
                                                                                                    type="checkbox"
                                                                                                    checked={selectedSskpis.find(x => x == ssk) != null ? true : false}
                                                                                                    className="custom-control-input"
                                                                                                    onChange={(e) => SelectToReject(ssk, e.target.id)}
                                                                                                    onClick={(e) => e.stopPropagation()}
                                                                                                />
                                                                                            </div>
                                                                                        </td>
                                                                                        <td style={{ ...(ssk.isHighlight ? { color: "#FBBA00" } : {}), width: "10%" }}>{ssk.isBold ? <b>{ssk.refNumber}</b> : ssk.refNumber}</td>
                                                                                        <td style={{ width: "50%" }}>{ssk.isBold ? <b>{ssk.kpiDescription}</b> : ssk.kpiDescription}</td>
                                                                                        <td style={{ width: "20%" }}>{ssk.isBold ? <b>{ssk.columnDesc}</b> : ssk.columnDesc}</td>
                                                                                        <td style={{ width: "10%" }}>
                                                                                            {ssk.answer != null &&
                                                                                                ssk.isBold ?
                                                                                                    <b>
                                                                                                        {formatValuesInTooltipNumber(ssk.answer, unitMeasure.decimalSeparator, unitMeasure.decimalPrecision, unitMeasure.suffix)}
                                                                                                    </b> :
                                                                                                    formatValuesInTooltipNumber(ssk.answer, unitMeasure.decimalSeparator, unitMeasure.decimalPrecision, unitMeasure.suffix)                                                                                                
                                                                                            }
                                                                                            
                                                                                        </td>
                                                                                    </tr>
                                                                                );
                                                                            })}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </Collapse>
                                                        </td>
                                                    </tr>
                                                </React.Fragment>
                                            );
                                        } else {
                                            // Item não agrupado
                                            const ssk = item.item;
                                            var unitMeasure = GetTypeInput(ssk.unitMeasure.unitMeasureID, ssk.unitMeasure.type);
                                            return (
                                                <tr key={`ungrouped-${ssk.subSectionKpiID}-${ssk.columnIndex}-${index}`}>
                                                    <td style={{ verticalAlign: "middle" }}>
                                                        <div className="custom-control custom-checkbox">
                                                            <input type="checkbox" checked={selectedSskpis.find(x => x == ssk) != null ? true : false} className="custom-control-input" onChange={(e) => SelectToReject(ssk, e.target.id)} />
                                                        </div>
                                                    </td>
                                                    <td style={ssk.isHighlight ? { color: "#FBBA00" } : {}}>{ssk.isBold ? <b>{ssk.refNumber}</b> : ssk.refNumber}</td>
                                                    <td>{ssk.isBold ? <b>{ssk.kpiDescription}</b> : ssk.kpiDescription}</td>
                                                    <td>{ssk.isBold ? <b>{ssk.columnDesc}</b> : ssk.columnDesc}</td>
                                                    <td>
                                                        {ssk.isBold
                                                            ? <b>{formatValuesInTooltipNumber(ssk.answer, unitMeasure.decimalSeparator, unitMeasure.decimalPrecision, unitMeasure.suffix, false, false, null)}</b>
                                                            : formatValuesInTooltipNumber(ssk.answer, unitMeasure.decimalSeparator, unitMeasure.decimalPrecision, unitMeasure.suffix, false, false, null)
                                                        }
                                                    </td>
                                                </tr>
                                            );
                                        }
                                    })
                                        :
                                        <tr>
                                            <td colSpan={6}>There is no data to list here</td>
                                        </tr>
                                    }
                                </tbody>
                            </table>

                            :
                            <CheckboxTree
                                nodes={groupedSSKpis}
                                checked={checked}
                                expanded={expanded}
                                onCheck={(e) => {
                                    setChecked(e);
                                    setSelectedSskpis(selectedFromCheckedValues(e, ssksToReject));
                                }}
                                onExpand={e => setExpanded(e)}
                                icons={{
                                    check: <MdCheckBox className="rct-icon-check" />,
                                    uncheck: <MdCheckBoxOutlineBlank className=" rct-icon-uncheck" />,
                                    halfCheck: <MdIndeterminateCheckBox className=" rct-icon-half-check" />,
                                    expandClose: <MdChevronRight className=" rct-icon-expand-close" />,
                                    expandOpen: <MdKeyboardArrowDown className=" rct-icon-expand-open" />,
                                    expandAll: <MdAddBox className=" rct-icon-expand-all" />,
                                    collapseAll: <MdIndeterminateCheckBox className=" rct-icon-collapse-all" />,
                                    parentClose: null,
                                    parentOpen: null,
                                    leaf: null
                                }}
                            />
                    }


                </>

                <div style={{ margin: "0.5rem 0" }}>
                    <Button className="reject-partial-btn" disabled={!(selectedSskpis?.length > 0)} style={{ margin: "0 1rem", float: "right", 'text-transform': "none" }} onClick={() => RejectSelectedSskpis()}> {userRoles.includes("RoleAdmin") ? 'REACTIVATE SELECTED KPIs' : 'REJECT SELECTED KPIs'}</Button>
                </div>

            </ModalBody>
        </Modal>
    );
}


